const trains = {
  train: "Kereta api", // translated 
  trains: "Kereta api", // translated 
  fairConditions: "Syarat-syarat Adil", // translated 
  to: "kepada", // translated 
  earlier: "Terdahulu", // translated 
  later: "Kemudian", // translated 
  adults: "Dewasa", // translated 
  child: "Kanak-kanak", // translated 
  senior: "Warga emas", // translated 
  seniors: "Warga emas", // translated 
  price: "Harga", // translated 
  for: "untuk", // translated 
  total: "Jumlah", // translated 
  selected: "Dipilih", // translated 
  prebook: "Pra-tempah", // translated 
  book: "Buku", // translated 
  payment: "Pembayaran", // translated 
  return: "Pulangan", // translated 
  passengers: "Penumpang", // translated 
  delivery: "Penghantaran", // translated 
  summary: "Ringkasan", // translated 
  checkout: "Daftar keluar", // translated 
  trainToastCorrectFillForm: "Sila isi semua ruangan dengan betul.", // translated 
  fareConditions: "Syarat tambang", // translated 
  travelInfo: "Maklumat perjalanan", // translated 
  remarks: "Komen pelanggan", // translated 
  noServices: "Tiada perkhidmatan", // translated 
  timesAndSeats: "Waktu dan tempat duduk", // translated 
  mobileTicket: "Tiket mudah alih", // translated 
  stationTicket: "Ambil di stesen", // translated 
  homeTicket: "Cetak di rumah", // translated 
  countryCode: "Kod negara", // translated 
  chooseTicket: "Pilih kaedah penghantaran tiket", // translated 
  ticketError: "Sila pilih tiket untuk semua destinasi", // translated 
  ticketDelivery: "Sila pilih kaedah penghantaran tiket", // translated 
  passengerDetails: "Butiran penumpang", // translated 
  waitWhileProcessingPayment:
    "Sila tunggu sementara kami memproses pembayaran anda, jangan muat semula atau tutup halaman ini.", // translated 
  reductionCardId: "ID kad pengurangan", // translated 
  countryOfResidence: "Negara tempat tinggal", // translated 
  countryOfBirth: "Negara kelahiran", // translated 
  documentCountry: "Negara dokumen", // translated 
  documentNumber: "Nombor dokumen", // translated 
  expirationDate: "Tarikh luput", // translated 
  documentType: "Jenis dokumen", // translated 
  travelerDocumentInfo: "Maklumat dokumen pengembara", // translated 
  youth: "Belia", // translated 
  youths: "Belia", // translated 
  departTimeEarlyFirst: "Waktu berlepas (paling awal dahulu)", // translated 
};






export default trains;
